<template>
  <BaseModal overlay-class="other_modals net_prob">
    <div class="content">
      <BaseImage src="/static/images/other/device_icon.svg" alt="Different Devices Icon" />

      <h3 class="title">{{ $_translations.value.modal_already_verified_email_title }}</h3>

      <p>{{ $_translations.value.modal_already_verified_email_description }}</p>
    </div>
  </BaseModal>
</template>

<script setup>

import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
</script>
